'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.stringable = stringable;

function stringable(thing) {
    return thing !== null && typeof thing !== 'undefined' && typeof (thing.toString === 'function');
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/reactable/lib/reactable/lib/stringable.js
 ** module id = 1200
 ** module chunks = 0
 **/